import { computed, defineComponent, h, onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";
import PushSubscribers from "./subscribers";

export type NotificationFactory = (notification: NotificationData) => void;
export default defineComponent({
  name: "PushManager",
  setup() {
    const isdDocumentHidden = ref(document.hidden);
    const shouldDelayNotification = computed(() => isdDocumentHidden.value);
    const onVisibilityChange = () => (isdDocumentHidden.value = document.hidden);
    onMounted(() => {
      document.addEventListener("visibilitychange", onVisibilityChange);
    });
    onBeforeUnmount(() => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
    });

    const sendNotification = (notification: NotificationData) => {
      if (!shouldDelayNotification.value) {
        emitter.emit(EVENTS.NOTIFICATION_SHOW, notification);
        return;
      }
      setTimeout(() => sendNotification(notification), 100);
    };
    PushSubscribers.forEach(subscriber => subscriber(sendNotification));
    return () => h();
  },
});
